var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllDrinkCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.905605,
    y: 0.905605,
    width: 43.469,
    height: 43.469,
    rx: 21.7345,
    stroke: "#FCC436",
    strokeWidth: 1.81121
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1771 25.355V32.9695H17.6653H17.5627V33.072V35.1229V35.2254H17.6653H28.9449H29.0474V35.1229V33.072V32.9695H28.9449H24.433V25.355L35.6859 13.0304L35.7127 13.0011V12.9613V10V9.89746H35.6102H11H10.8975V10V12.9613V13.0011L10.9243 13.0304L22.1771 25.355ZM13.1783 12.1534H33.4318L30.3422 15.5373H16.268L13.1783 12.1534ZM18.3277 17.7932H28.2824L23.3202 23.228H23.2899L18.3277 17.7932Z",
    fill: "#FCC436",
    stroke: "#FCC436",
    strokeWidth: 0.205085
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3051 26.4067L16.2008 17.1779L30.4094 17.1779L23.3051 26.4067Z",
    fill: "#FCC436"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllDrinkCat);
export default __webpack_public_path__ + "static/media/allDrinkCat.03f656cb9efbf78f6ecfa844232af083.svg";
export { ForwardRef as ReactComponent };